import React from "react"
import { Popup } from "semantic-ui-react"
import { ensureCorrectPopupPosition } from "../../utils/popup-tools"

function copyToClipboard(textToCopy: string) {
  // navigator clipboard api needs a secure context (https)
  if (navigator.clipboard && window.isSecureContext) {
    // navigator clipboard api method'
    return navigator.clipboard.writeText(textToCopy)
  } else {
    // text area method
    const textArea = document.createElement("textarea")
    textArea.value = textToCopy
    // make the textarea out of viewport
    textArea.style.position = "fixed"
    textArea.style.left = "-999999px"
    textArea.style.top = "-999999px"
    textArea.style.opacity = "0"
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    return new Promise((res, rej) => {
      // here the magic happens
      document.execCommand("copy") ? res(true) : rej()
      textArea.remove()
    })
  }
}

interface ICopiableProps {
  text?: string | number
  component: JSX.Element
  hoverText: string
  clickedText: string
  containerClassName?: string
  popupPosition?:
    | "top left"
    | "top right"
    | "bottom right"
    | "bottom left"
    | "right center"
    | "left center"
    | "top center"
    | "bottom center"
  popupClassName?: string
}

export const Copiable = ({
  text,
  component,
  hoverText,
  clickedText,
  popupPosition = "right center",
  containerClassName = "",
  popupClassName,
}: ICopiableProps) => {
  const [popupText, setPopupText] = React.useState("")
  React.useEffect(() => setPopupText(hoverText), [hoverText])

  const handleClosePopup = () => setPopupText(hoverText)

  const handleCopy: React.MouseEventHandler<HTMLSpanElement> = (event) => {
    event.stopPropagation()
    setPopupText(clickedText)

    copyToClipboard(text + "").then(
      () => {
        console.log("Async: Copying to clipboard was successful!")
      },
      (err: any) => {
        console.error('Async: Could not copy "' + text + '" : ', err)
      }
    )
  }

  const cs = `${popupClassName ? popupClassName : ""}`

  return text === undefined ? (
    component
  ) : (
    <Popup
      trigger={
        <span
          className={containerClassName + " copiable-span"}
          onClick={handleCopy}
        >
          {component}
        </span>
      }
      content={popupText}
      popperDependencies={[popupText]}
      inverted
      on="hover"
      onClose={handleClosePopup}
      className={cs}
      {...ensureCorrectPopupPosition}
      position={popupPosition}
    />
  )
}
